import { Link, useParams } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';
import { KWELLO_ICON, KwelloSvgIcon } from '../icon/KwelloSvgIcon';
import { USER_ROUTES } from 'routes/routes.const';
import { PROJECT_ID_PLACEHOLDER } from 'common/constants';
import { useSelector } from 'react-redux';
import {
  selectIsExportRunningInBackground,
  selectExportProgress,
} from '../../store/slices/export-ppt.slice';
import { BadgeContainer, Badge } from '@progress/kendo-react-indicators';

export const MyFilesLink = () => {
  const { projectId } = useParams();
  const isRunningExportInBackgroundPPT = useSelector(selectIsExportRunningInBackground);
  const exportProgress = useSelector(selectExportProgress);

  return (
    <div className="user-files-link" data-tooltip-id="my-files-link">
      <BadgeContainer>
        <Link
          target="_blank"
          to={USER_ROUTES.files.replace(PROJECT_ID_PLACEHOLDER, projectId as string)}
        >
          <KwelloSvgIcon icon={KWELLO_ICON.FOLDER_DOWNLOAD} className="user-files-icon" />
          {isRunningExportInBackgroundPPT && (
            <Badge rounded={'full'} themeColor={'error'}>
              1
            </Badge>
          )}
        </Link>
      </BadgeContainer>

      <Tooltip id="my-files-link" place="bottom" positionStrategy={'fixed'}>
        My Files{' '}
        {isRunningExportInBackgroundPPT && (
          <span className="export-progress">
            <span className="export-progress-text">| Exporting Multi Question Powerpoint: </span>
            <span className="export-progress-value">{exportProgress}%</span>
          </span>
        )}
      </Tooltip>
    </div>
  );
};
